module.exports = __webpack_public_path__ + "img/fi-rr-diploma.99fa43ff.svg";